module.exports = __webpack_public_path__ + "static/img/bg1.536d7a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youkuCard/bg1.png
// module id = DP5F
// module chunks = 1